import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { CustomField } from '@/Atomic/Organisms/CustomField'
import { Modal } from '@/Atomic/Organisms/Modal'
import { Form, FormBody, FormFields } from '@/Atomic/Templates/Form'
import { useDataItemFormHandler } from '@/utils/CRUD/hooks/useDataItemFormHandler'
import { getDataItemFormMap } from '@/utils/CRUD/read/dataItem/getDataItemMap'

import './RenameFolderModal.scss'

export interface RenameFolderModalProps {
  isOpen: boolean
  close: () => void
  document: DataItem
}

export const RenameFolderModal: React.FC<RenameFolderModalProps> = ({
  isOpen,
  close,
  document,
}) => {
  const { t } = useTranslation()
  const { methods } = useDataItemFormHandler(document)
  const { handleSubmit, reset, getValues, watch } = methods

  const handleSave = () => {
    handleSubmit(async (data) => {
      await document.update({ title: data.title })
      reset()
      close()
    })()
  }

  const handleCancel = () => {
    reset()
    close()
  }

  const groups = getDataItemFormMap(document, getValues, watch)
  const titleField = groups
    .flatMap((group) => group.fields)
    .find((field) => field.name === 'title')

  return (
    <Modal
      className="rename-folder-modal"
      onClose={handleCancel}
      isOpen={isOpen}
    >
      <Modal.Header title={t('components.document.renameFolder')} />
      <Modal.Body>
        <FormProvider {...methods}>
          <Form onSubmit={handleSave}>
            <FormBody>
              <FormFields>
                {titleField && (
                  <CustomField
                    fieldMap={titleField}
                    isEditing
                    className="form-field"
                  />
                )}
              </FormFields>
            </FormBody>
          </Form>
        </FormProvider>
      </Modal.Body>
      <Modal.Footer
        onCancel={handleCancel}
        onCancelText={t('common.cancel')}
        onConfirm={handleSave}
        onConfirmText={t('components.document.renameFolder')}
      />
    </Modal>
  )
}
